import routes from '@/router/routes.constants';

const MY_PROP_BASE = [
  routes.MY_PROPOSITIONS,
  routes.EDIT_PROPOSITION,
  routes.MY_VISITORS
];

// Mitt konto and its login details sit under the edit-listing path in SE,
// DE and DK (/redigera/profil), but they belong to the account, not Min annons.
const ACCOUNT = [routes.EDIT_PROFILE, routes.EDIT_USER_CREDENTIALS];

const matchesPrefix = (path, prefix) =>
  path === prefix || path.startsWith(`${prefix}/`);

const matchesAny = (path, prefixes) =>
  prefixes.some(p => matchesPrefix(path, p));

export function getActiveNavItem({ path, query }) {
  // A page the swap list opened (its wishes' areas) belongs to the list.
  if (query && query.from === 'swaplist') return 'swapList';

  if (matchesPrefix(path, routes.SWAP_LIST)) return 'swapList';
  if (matchesPrefix(path, routes.MATCHES)) return 'matches';

  if (matchesAny(path, ACCOUNT)) return null;
  if (matchesAny(path, MY_PROP_BASE)) return 'myProp';

  return null;
}
